import { useState } from "react";

import { Switch } from "@/components/ui";
import { leafLabel } from "@/lib/attributeReview/kindWords";
import { chip } from "../ReviewDrawer/agentStyles";
import type { Pool } from "./PoolSection";

type Props = {
  pool: Pool;
  canSwitch: boolean;
  setSellerTyping: (pool: string, allowed: boolean) => Promise<unknown>;
};

export function PoolValueList({ pool, canSwitch, setSellerTyping }: Props) {
  const [mayType, setMayType] = useState(pool.restriction_mode !== "closed");
  const values = pool.values ?? [];
  return (
    <div className="space-y-2 text-sm">
      <p>
        List: <b title={pool.key}>{leafLabel(pool.key)}</b> · {values.length}{" "}
        values,{" "}
        {pool.source === "existing"
          ? "fixed by the field"
          : "goes onto the field when this job finishes"}
      </p>
      <ul className="flex max-h-40 flex-wrap gap-1 overflow-y-auto">
        {values.map((v) => (
          <li key={v.key} className={chip}>
            {v.label}
          </li>
        ))}
      </ul>
      {canSwitch && pool.restriction_mode && (
        <label className="flex items-center gap-2">
          <Switch
            checked={mayType}
            onCheckedChange={(allowed) =>
              setSellerTyping(pool.key, allowed)
                .then(() => setMayType(allowed))
                .catch(() => undefined)
            }
          />
          Let sellers type a value not in this list. Applies to every store
          using it.
        </label>
      )}
    </div>
  );
}
